<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>ADD_ORDER_ROW</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th translate>ITEM_NO</th>
              <th translate>QUANTITY</th>
              <th translate *ngIf="cartListCheckoutConfig.enableSalesEditPrice && isSalesOrAdmin">PRICE</th>
              <th translate *ngIf="cartListCheckoutConfig.enableSalesEditDiscount && isSalesOrAdmin">DISCOUNT</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of modalRows; let rowIndex = index" (keydown.enter)="focusNextInput($event)">
              <td class="select-product">
                <lib-product-select-dropdown
                  #productElement
                  (productSelected)="selectProduct($event, rowIndex, productElement)"
                  [formatterFunction]="productSearchFormatter"
                  [formatterInputFunction]="productSearchInputFormatter"
                ></lib-product-select-dropdown>
              </td>
              <td>
                <lib-product-quantity-input
                  [productId]="row.productId"
                  [product]="row.productObject"
                  [price]="row.priceObject"
                  [(ngModel)]="row.qty"
                ></lib-product-quantity-input>
              </td>
              <td *ngIf="cartListCheckoutConfig.enableSalesEditPrice && isSalesOrAdmin">
                <input class="form-control" type="number" [(ngModel)]="row.price" [placeholder]="row.priceObject?.customerGrossPrice?.value || 0" />
              </td>
              <td *ngIf="cartListCheckoutConfig.enableSalesEditDiscount && isSalesOrAdmin">
                <input class="form-control" type="number" [(ngModel)]="row.discount" [placeholder]="row.priceObject?.customerDiscountPercent || 0" />
              </td>
              <td width="5%">
                <i class="fa fa-trash-alt clickable" (click)="removeRow(rowIndex)"></i>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <button class="btn btn-primary btn-block" (click)="addNewRow()" translate>ADD_ORDER_ROW</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button *ngIf="true" type="button" class="btn btn-primary" (click)="submitRows()" translate>ADD_ROWS_TO_ORDER</button>
</div>
